
import { Component, Input, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ElementRefDirective } from '@ay-gosu/ui/common/element-ref';
import { FileDirective } from '../../components/file.directive';
import { MatTooltip } from '../../material/tooltip/tooltip';
import { MessageToolbar } from '../factory/message-toolbar';
import { Package } from '../package.class';

@Component({
    selector: 'ms-submenu',
    templateUrl: './submenu.component.html',
    styleUrls: ['./submenu.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
    inputs: ['package'],
    exportAs: 'msSubmenu',
    imports: [
    MatMenu,
    MatMenuItem,
    MatIcon,
    MatTooltip,
    FileDirective,
    MatMenuTrigger,
    ElementRefDirective
]
})
export class SubmenuComponent {
  @Input()
  public package: Package;

  @Input()
  public toolbars: MessageToolbar[];

  @ViewChild('matMenu', { static: true })
  public matMenu: MatMenu;

  public async loadSubmenu(toolbar: MessageToolbar) {
    if (toolbar.submenuFn) {
      toolbar.submenu = await toolbar.submenuFn();
    }
  }
}
